
import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import { IProfileState } from '~/store/profile/types';

interface IStep {
  header: string;
  body: string;
  onClick?: () => void;
}

@Component
export default class RewardsSteps extends Vue {
  @State((profile: IProfileState) => profile.user.loggedIn, {
    namespace: 'profile',
  })
  loggedIn!: boolean;

  @Mutation('toggleRegisterDialog')
  private toggleRegisterDialog!: (args: any) => void;

  get heading() {
    return this.$t(
      'components.nodes.rewardsSteps.aRewardingExperience',
    ) as string;
  }
  get body() {
    return this.$t('components.nodes.rewardsSteps.itTakesJust') as string;
  }

  steps: IStep[] = [];

  created() {
    this.steps = [
      {
        header: this.$t('components.nodes.rewardsSteps.1Join') as string,
        body: this.$t('components.nodes.rewardsSteps.stayUpToDate') as string,
        // onClick: !this.loggedIn
        //   ? () => this.toggleRegisterDialog(true)
        //   : undefined,
      },
      {
        header: this.$t('components.nodes.rewardsSteps.2Buy') as string,
        body: this.$t(
          'components.nodes.rewardsSteps.nodesCanBePurchased',
        ) as string,
        // onClick: () => this.goTo(`/nodes/film-node/buy`),
      },
      {
        header: this.$t('components.nodes.rewardsSteps.3Operate') as string,
        body: this.$t(
          'components.nodes.rewardsSteps.yourGalaFilmNode',
        ) as string,
        // onClick: this.loggedIn
        //   ? () => this.goTo(`/account?settings=my-node`)
        //   : undefined,
      },
      {
        header: this.$t('components.nodes.rewardsSteps.4Reward') as string,
        body: this.$t(
          'components.nodes.rewardsSteps.toReceiveRewards',
        ) as string,
      },
    ];
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
